<template>
    <b-modal :id="id" :size="size" ref="modal" hide-header centered>
        <slot></slot>
        <template #modal-footer>
            <b-button variant="primary standard-btn" @click="okModal" >
                Ok
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
            validator: function (value) {
                // the id must end with -modal otherwise the styling on the ok button will fail.
                return value.endsWith('-modal');
            }
        },
        message: String,
        size: String,
    },
    methods: {
        okModal() {
            this.$refs.modal.hide();
        }
    }

};
</script>